import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as sideBarActions from '../../redux/sideBarActions';
import { bindActionCreators } from 'redux';
import { string } from '../../localization';
import './UploadDialogue.scss';

class DropBoxErrorDialogue extends Component {
  handleOKClick = () => {
    const { dispatchers } = this.props;
    const dict = {
      header: string.DROPBOX_IMPORT_ERROR_HEADER,
      contents: []
    };
    dispatchers.sideBarActions.setDropBoxErrorParams(dict);
    dispatchers.sideBarActions.setDropBoxErrorFlag(false);
  };

  render() {
    const { dropBoxErrorFlag, dropBoxDict } = this.props;

    return (
      <div>
        <Modal
          className='dropbox-error-modal'
          isOpen={dropBoxErrorFlag}
          contentClassName='border-0 bg-transparent'
          backdropClassName='dropbox-error-backdrop'
          centered
        >
          <ModalBody className='rounded-1'>
            <div>
              <p
                style={{
                  fontSize: '20px',
                  marginBottom: '12px',
                  color: '#4A4A4A',
                  font: 'bold 20px/26px HPSimplifiedLight, Arial, sans-serif'
                }}
              >
                {string.DROPBOX_IMPORT_ERROR_HEADER}
              </p>

              <div>
                {dropBoxDict.contents.map(content => (
                  <div className=' d-flex dropbox-error-page'>
                    <div className='dropbox-error-name-cell'>
                      {content.fileName}
                    </div>
                    <div className='dropbox-error-description-cell'>
                      {content.description}
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  float: 'right',
                  marginTop: '20px'
                }}
              >
                <button
                  type='button'
                  className='error-ok-button'
                  onClick={this.handleOKClick}
                  style={{
                    marginBottom: '10px',
                    border: 'none',
                    outline: 'none'
                  }}
                >
                  <text className='error-label'>{string.OK_KEY}</text>
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dropBoxDict: state.sideBar.dropBoxErrorDict,
    dropBoxErrorFlag: state.sideBar.dropBoxErrorFlag
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropBoxErrorDialogue);
